// react
import { useContext } from 'react';

// context
import { ContextInflows } from '../../Project.context';

// mui
import { Container, Grid } from '@mui/material';

// tables
import { TableInflows } from '../../../../tables/cards/TableInflows/TableInflows';

export const Inflows = () => {
	// context
	const { inflows, isLoadingInflow, paginationInflow, refetchInflow } = useContext(ContextInflows);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TableInflows
						isLoading={isLoadingInflow}
						pagination={paginationInflow}
						refetchTransactions={refetchInflow}
						transactions={inflows}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
